export const ERR_INVALID_CARD_TYPE = 'ERR_INVALID_CARD_TYPE';
